<template>
  <tr>
    <td class="message" colspan="2">
      <ErrorIcon /> <br />
      {{ "definitionsPage.errorLine1" | t }}<span class="search-term">{{ searchTerm }}</span
      >. <br />
      {{ "definitionsPage.errorLine2" | t
      }}<a id="support-email" href="mailto:japan@virtusize.com">japan@virtusize.com</a
      >{{ "definitionsPage.errorLine3" | t }}
    </td>
  </tr>
</template>

<script>
import ErrorIcon from "@/assets/logos/icon-error.svg";

export default {
  components: {
    ErrorIcon,
  },
  props: ["searchTerm"],
};
</script>

<style scoped lang="scss">
td[colspan="2"].message {
  height: 196px;
  padding: 10px;
  border: 1px solid #dedede;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;

  .search-term {
    font-weight: 600;
  }

  #support-email {
    color: #16c6b9;
    text-decoration: none;
  }
}
</style>
